import React, { useState, useEffect } from "react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import { useParams } from 'react-router-dom';
import axios from "axios";
import Loader from '../components/Loader'

const BlogDetails = () => {
  let { slug } = useParams();  
  const [loading, setLoading] = useState(true);  
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  
  const [data, setData] = useState('')
  const apiUrl = apiBaseUrl+`post/details/${slug}`;  
  

  const fetchInfo = () => {
    return axios.get(apiUrl).then((res) => {
      setData(res.data.post)
    });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, []);  

  function createMarkup(data) {
    return { __html: data };
  }
  

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  };


  return (
    <>
    <Header/>
    { loading && (<Loader /> )}
    <section className="section-content-block">
      <div className="container">

            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                <div className="about-us-intro">
                  <h2 className="heading">{data?.post_title}</h2>
                  <p>{data?.short_description}</p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                <div className="Products story-banner">
                  {data?.image && (
                    <img src={`${siteUrl}${data?.image}`} alt={data?.slug} />
                  )}
                  
                </div>                            
              </div> 
            </div>  

            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 px-50">   
                <div className="Products case-des blog-detail">
                  <h4 className="heading">{data.post_title}</h4> 
                  <div dangerouslySetInnerHTML={createMarkup(data?.description)}></div>
                </div>
              </div>
            </div>

      </div>
    </section>


    <Footer/>
    </>
  )
}

export default BlogDetails